module.exports = __webpack_public_path__ + "static/media/image7.5b0ace39.PNG";